import ModalHeader from './component.styles'
export default ModalHeader
